module.exports = __webpack_public_path__ + "static/LCScriptWeb-Regular-4278eac1bb69145724141cc13e8dd176.eot";